<div
  class="srd"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <div class="srd-drop" *ngIf="dragging()">
    <mat-icon>upload_file</mat-icon>
    {{ "support_chat.drop_files" | translate }}
  </div>

  <header class="srd-header">
    <span class="srd-header-icon" [class.srd-header-icon--done]="step() === 'done'">
      <mat-icon>{{ step() === "done" ? "task_alt" : "bug_report" }}</mat-icon>
    </span>
    <div class="srd-header-text">
      <h2 mat-dialog-title>
        {{
          (step() === "done"
            ? "support_chat.report_done_title"
            : step() === "confirm"
              ? "support_chat.report_confirm_title"
              : "support_chat.report_issue"
          ) | translate
        }}
      </h2>
      <p *ngIf="step() === 'form'">
        {{ "support_chat.report_intro" | translate }}
        <ng-container *ngIf="data.showTarget && data.target">
          · {{ "support_chat.report_for_shop" | translate: { target: data.target } }}
        </ng-container>
      </p>
    </div>
    <button
      type="button"
      class="srd-icon-btn"
      (click)="close()"
      [disabled]="sending()"
      [attr.aria-label]="'support_chat.close' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <!-- ================================ Form ================================ -->
  <div class="srd-body" *ngIf="step() === 'form'">
    <div class="srd-row">
      <div class="srd-field">
        <label class="srd-label" id="srd-product-label">
          {{ "support_chat.report_product" | translate }}
        </label>
        <mat-form-field class="bhm-option-container-1 medium-height-container">
          <mat-select
            [(ngModel)]="product"
            aria-labelledby="srd-product-label"
            [placeholder]="'support_chat.report_product_placeholder' | translate"
            [disabled]="sending()"
          >
            <mat-option
              *ngFor="let option of products"
              class="bhm-option-select-option-1"
              [value]="option.key"
            >
              {{ option.titleKey | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="srd-field">
        <label class="srd-label" id="srd-device-label">
          {{ "support_chat.report_device" | translate }}
          <span class="srd-optional">{{ "support_chat.optional" | translate }}</span>
        </label>
        <mat-form-field class="bhm-option-container-1 medium-height-container">
          <mat-select
            [(ngModel)]="device"
            aria-labelledby="srd-device-label"
            [placeholder]="'support_chat.report_device_any' | translate"
            [disabled]="sending()"
          >
            <mat-option class="bhm-option-select-option-1" [value]="null">
              {{ "support_chat.report_device_any" | translate }}
            </mat-option>
            <mat-option
              *ngFor="let option of devices"
              class="bhm-option-select-option-1"
              [value]="option"
            >
              {{ "support_chat.device_" + option | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Nudge reports: the nudges it is about, and whether to turn them off -->
    <section class="srd-nudges" *ngIf="showNudges">
      <label class="srd-label" id="srd-nudges-label" for="srd-nudge-input">
        {{ "support_chat.report_nudges_label" | translate }}
        <span class="srd-optional">{{ "support_chat.optional" | translate }}</span>
      </label>
      <ng-container [ngSwitch]="nudgesState()">
        <p class="srd-muted" *ngSwitchCase="'loading'" role="status">
          {{ "support_chat.report_nudges_loading" | translate }}
        </p>
        <p class="srd-muted" *ngSwitchCase="'error'" role="alert">
          {{ "support_chat.report_nudges_error" | translate }}
          <button type="button" class="srd-link" (click)="loadNudges()">
            {{ "support_chat.retry" | translate }}
          </button>
        </p>
        <ng-container *ngSwitchCase="'ready'">
          <p class="srd-muted" *ngIf="!nudges().length">
            {{ "support_chat.report_nudges_none_live" | translate }}
          </p>
          <ng-container *ngIf="nudges().length">
            <div
              class="srd-ids"
              [class.srd-ids--invalid]="invalidNudgeInput()"
              [class.srd-ids--disabled]="sending()"
              matAutocompleteOrigin
              #nudgeOrigin="matAutocompleteOrigin"
              (click)="nudgeInput.focus()"
            >
              <span class="srd-chip" *ngFor="let id of nudgeIds()">
                <span class="srd-chip-text">
                  {{ nudgeName(id) }}<small *ngIf="nudgeName(id) !== id">{{ id }}</small>
                </span>
                <button
                  type="button"
                  (click)="removeNudge(id); $event.stopPropagation()"
                  [disabled]="sending()"
                  [attr.aria-label]="'support_chat.report_nudges_remove' | translate: { id: id }"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </span>
              <input
                #nudgeInput
                id="srd-nudge-input"
                type="text"
                autocomplete="off"
                aria-labelledby="srd-nudges-label"
                [attr.aria-invalid]="!!invalidNudgeInput()"
                [placeholder]="
                  nudgeIds().length ? '' : ('support_chat.report_nudges_placeholder' | translate)
                "
                [ngModel]="nudgeQuery()"
                (ngModelChange)="onNudgeQuery($event)"
                (keydown)="onNudgeKeydown($event)"
                (blur)="onNudgeBlur()"
                [disabled]="sending()"
                [matAutocomplete]="nudgeAuto"
                [matAutocompleteConnectedTo]="nudgeOrigin"
              />
            </div>
            <mat-autocomplete
              #nudgeAuto="matAutocomplete"
              class="srd-nudge-panel"
              [autoActiveFirstOption]="!!nudgeQuery().trim()"
              (optionSelected)="pickNudge($event.option.value)"
              (closed)="onNudgeSuggestionsClosed()"
            >
              <mat-option
                *ngFor="let nudge of nudgeSuggestions()"
                class="srd-nudge-option"
                [value]="nudge.id"
              >
                <span class="srd-nudge-name">{{ nudge.name || nudge.id }}</span>
                <small class="srd-nudge-meta" *ngIf="nudge.name">{{ nudge.id }}</small>
              </mat-option>
              <mat-option
                *ngIf="!nudgeSuggestions().length && nudgeQuery().trim() && !invalidNudgeInput()"
                class="srd-nudge-option"
                disabled
              >
                {{ "support_chat.report_nudges_no_match" | translate }}
              </mat-option>
            </mat-autocomplete>
            <p class="srd-field-error" *ngIf="invalidNudgeInput() as value" role="alert">
              {{ "support_chat.report_nudges_invalid" | translate: { value: value } }}
            </p>
          </ng-container>
        </ng-container>
      </ng-container>

      <div class="srd-stop" *ngIf="showStopNudges">
        <mat-checkbox [(ngModel)]="stopNudges" [disabled]="sending()">
          {{ "support_chat.stop_nudge_label" | translate }}
        </mat-checkbox>
        <p class="srd-hint" *ngIf="stopNudges">
          <mat-icon>info_outline</mat-icon>
          <span>{{ "support_chat.report_nudges_hint" | translate }}</span>
        </p>
      </div>
    </section>

    <label class="srd-label" for="srd-message">
      {{ "support_chat.report_label" | translate }}
    </label>
    <div class="srd-box">
      <textarea
        id="srd-message"
        cdkFocusInitial
        cdkTextareaAutosize
        cdkAutosizeMinRows="6"
        cdkAutosizeMaxRows="12"
        [(ngModel)]="message"
        [maxlength]="maxLength"
        [placeholder]="'support_chat.report_placeholder' | translate"
        [disabled]="sending()"
        (paste)="onPaste($event)"
      ></textarea>
      <div class="srd-box-actions" *ngIf="canAttach">
        <span class="srd-box-hint">{{
          "support_chat.files_hint" | translate: { max: maxFileMb }
        }}</span>
        <button
          type="button"
          class="srd-icon-btn srd-attach"
          (click)="pickFiles()"
          [disabled]="sending()"
          [title]="'support_chat.add_files' | translate"
          [attr.aria-label]="'support_chat.add_files' | translate"
        >
          <mat-icon>attach_file</mat-icon>
        </button>
      </div>
    </div>
    <input
      #filePicker
      type="file"
      class="srd-file-picker"
      multiple
      [accept]="fileAccept"
      (change)="onFilesPicked(filePicker)"
      tabindex="-1"
      aria-hidden="true"
    />

    <ul class="srd-tray" *ngIf="files.count()">
      <li
        *ngFor="let item of files.items()"
        class="srd-tray-item"
        [class.is-failed]="item.status === 'failed'"
      >
        <img
          *ngIf="item.previewUrl; else trayIcon"
          class="srd-tray-thumb"
          [src]="item.previewUrl"
          alt=""
          (error)="files.dropPreview(item.localId)"
        />
        <ng-template #trayIcon>
          <mat-icon class="srd-tray-icon">{{ fileIcon(item.file.type) }}</mat-icon>
        </ng-template>
        <span class="srd-tray-text">
          <strong [title]="item.file.name">{{ item.file.name }}</strong>
          <small *ngIf="item.status === 'failed'" class="srd-error-text">
            {{ uploadFailureKey(item) | translate }}
            <button type="button" class="srd-link" (click)="files.retry(item.localId)">
              {{ "support_chat.retry" | translate }}
            </button>
          </small>
          <small *ngIf="item.status === 'uploading'"
            >{{ item.progress * 100 | number: "1.0-0" }}%</small
          >
          <small *ngIf="item.status === 'done'">{{ fileSize(item.file.size) }}</small>
        </span>
        <button
          type="button"
          class="srd-icon-btn srd-tray-remove"
          (click)="removeFile(item.localId)"
          [disabled]="sending()"
          [attr.aria-label]="'support_chat.remove_file' | translate: { name: item.file.name }"
        >
          <mat-icon>close</mat-icon>
        </button>
        <span
          class="srd-tray-progress"
          *ngIf="item.status === 'uploading'"
          [style.width.%]="item.progress * 100"
        ></span>
      </li>
    </ul>
    <p class="srd-notice" *ngIf="attachmentNotice() as notice" role="alert">
      {{ notice.key | translate: notice.params }}
    </p>

    <p class="srd-error" *ngIf="errorKey() as key" role="alert">
      <mat-icon>error_outline</mat-icon>
      <span>{{ key | translate }}</span>
    </p>
  </div>

  <!-- ============================== Confirm =============================== -->
  <div class="srd-body" *ngIf="step() === 'confirm'">
    <p>{{ "support_chat.report_confirm_text" | translate }}</p>
    <ul class="srd-nudge-list">
      <li *ngFor="let id of nudgeIds()">
        <mat-icon>pause_circle</mat-icon>
        <span>
          <strong>{{ nudgeName(id) }}</strong>
          <small *ngIf="nudgeName(id) !== id">{{ id }}</small>
        </span>
      </li>
    </ul>
    <p class="srd-muted">{{ "support_chat.report_confirm_back_on" | translate }}</p>
  </div>

  <!-- ================================ Done ================================ -->
  <div class="srd-body" *ngIf="step() === 'done' && result() as done">
    <p>{{ "support_chat.report_done_text" | translate }}</p>
    <p class="srd-muted" *ngIf="done.email.status === 'queued'">
      {{ "support_chat.report_done_email" | translate: { email: done.email.to } }}
    </p>

    <ng-container *ngIf="outcomes().off.length">
      <h3 class="srd-subtitle">{{ "support_chat.report_done_turned_off" | translate }}</h3>
      <ul class="srd-nudge-list">
        <li *ngFor="let id of outcomes().off">
          <mat-icon class="srd-ok">check_circle</mat-icon>
          <span>
            <strong>{{ nudgeName(id) }}</strong>
            <small *ngIf="nudgeName(id) !== id">{{ id }}</small>
          </span>
        </li>
      </ul>
    </ng-container>
    <p class="srd-error" *ngFor="let id of outcomes().failed" role="alert">
      <mat-icon>error_outline</mat-icon>
      <span>{{ "support_chat.report_done_failed" | translate: { id: nudgeName(id) } }}</span>
    </p>
  </div>

  <footer class="srd-footer">
    <ng-container [ngSwitch]="step()">
      <ng-container *ngSwitchCase="'form'">
        <button type="button" class="srd-btn srd-btn--ghost" (click)="close()" [disabled]="sending()">
          {{ "support_chat.cancel" | translate }}
        </button>
        <button type="button" class="srd-btn" (click)="submit()" [disabled]="!canSubmit">
          {{ (sending() ? "support_chat.sending" : "support_chat.send_report") | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="'confirm'">
        <button type="button" class="srd-btn srd-btn--ghost" (click)="backToForm()" [disabled]="sending()">
          {{ "support_chat.back" | translate }}
        </button>
        <button type="button" class="srd-btn srd-btn--danger" (click)="submit()" [disabled]="sending()">
          {{ (sending() ? "support_chat.sending" : "support_chat.report_confirm_send") | translate }}
        </button>
      </ng-container>
      <button *ngSwitchCase="'done'" type="button" class="srd-btn" (click)="close()" cdkFocusInitial>
        {{ "support_chat.report_done" | translate }}
      </button>
    </ng-container>
  </footer>
</div>
